import Base from '@/components/Base';
import StudioModal from '@/components/modals/StudioModal.vue';
import { EModalName } from '@/helpers/modal';
import { Component } from 'vue-property-decorator';

@Component({
  components: {
    StudioModal,
  },
}) export default class VideoPlayerModal extends Base {
  videoUrl: string = null;

  get modalName(): string {
    return EModalName.videoPlayer;
  }

  beforeOpen({ params }) {
    if (params.videoUrl)
      this.videoUrl = params.videoUrl;
  }
}
